import BenchmarkStudyService from 'src/modules/benchmarkStudy/benchmarkStudyService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'BENCHMARKSTUDY_VIEW';

const benchmarkStudyViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: benchmarkStudyViewActions.FIND_STARTED,
      });

      const record = await BenchmarkStudyService.find(id);

      dispatch({
        type: benchmarkStudyViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: benchmarkStudyViewActions.FIND_ERROR,
      });

      getHistory().push('/benchmark-study');
    }
  },
};

export default benchmarkStudyViewActions;
